import React, {FC} from 'react';
import './App.css';
import EventCalendar from "./pages/eventCalendar";
import {Layout} from "antd";
import moment from 'moment';
import 'moment/locale/ru';
moment.locale('ru');

const App: FC = () => {
  return (
    <Layout>
        <Layout.Content>
            <EventCalendar />
        </Layout.Content>
    </Layout>
  );
}

export default App;
